export const Marcadores = [0, .40, 1];
